import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import configs from './routes/Admin/Core/Configs'
import users from './routes/Admin/Core/Users'
import userTypes from './routes/Admin/Core/User_types'
/* ADMIN:DEFINES */
import accountTypes from './routes/Admin/Defines/Account_types'
import banks from './routes/Admin/Defines/Banks'
import cities from './routes/Admin/Defines/Cities'
import currencies from './routes/Admin/Defines/Currencies'
import districts from './routes/Admin/Defines/Districts'
import donationTypes from './routes/Admin/Defines/Donation_types'
/* ADMIN:APP */
import accountActivities from './routes/Admin/App/Account_activities'
import bankAccounts from './routes/Admin/App/Bank_accounts'
import donationGroups from './routes/Admin/App/Donation_groups'
import estates from './routes/Admin/App/Estates'
import tenants from './routes/Admin/App/Tenants'
import promissories from './routes/Admin/App/Promissories'
import safes from './routes/Admin/App/Safes'
import reports from './routes/Admin/App/Reports'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...configs,
    ...users,
    ...userTypes,
    ...cities,
    ...accountTypes,
    ...currencies,
    ...banks,
    ...districts,
    ...donationTypes,
    ...accountActivities,
    ...bankAccounts,
    ...donationGroups,
    ...estates,
    ...tenants,
    ...promissories,
    ...safes,
    ...reports,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
